"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function clamp(num, min, max) {
    return Math.min(Math.max(num, min), max);
}
exports.clamp = clamp;
//# sourceMappingURL=utils.js.map